(function () {
  var section = document.querySelector("[data-build-box]");
  if (!section) return;

  var purchaseBtns = section.querySelectorAll("[data-build-purchase]");
  var freqsContainer = section.querySelector("[data-build-freqs]");
  var freqBtns = section.querySelectorAll("[data-build-freq]");
  var packBtns = section.querySelectorAll("[data-build-pack]");
  var flavourCards = section.querySelectorAll("[data-build-flavour]");
  var progress = section.querySelector("[data-build-progress]");
  var progressCount = section.querySelector("[data-build-progress-count]");
  var progressRemain = section.querySelector("[data-build-progress-remain]");
  var progressFill = section.querySelector("[data-build-progress-fill]");
  var progressCheck = section.querySelector("[data-build-progress-check]");
  var sidebarPack = section.querySelector("[data-build-sidebar-pack]");
  var sidebarPurchase = section.querySelector("[data-build-sidebar-purchase]");
  var sidebarPurchaseMeta = section.querySelector("[data-build-sidebar-purchase-meta]");
  var sidebarSave = section.querySelector("[data-build-sidebar-save]");
  var sidebarFlavours = section.querySelector("[data-build-sidebar-flavours]");
  var sidebarTotal = section.querySelector("[data-build-sidebar-total]");
  var sidebarDelivery = section.querySelector("[data-build-sidebar-delivery]");
  var sidebarDeliveryText = section.querySelector("[data-build-sidebar-delivery-text]");
  var sidebarDeliveryPrice = section.querySelector("[data-build-sidebar-delivery-price]");
  var checkoutBtn = section.querySelector("[data-build-checkout]");
  var flavoursHint = section.querySelector("[data-build-flavours-hint]");

  function getBoxPriceCents() {
    var price = state.priceCents;
    if (state.mode === "subscribe" && state.discount > 0) {
      price = Math.round(price * (1 - state.discount / 100));
    }
    return price;
  }

  function getFreeShippingThresholdCents() {
    var cartDrawer = document.querySelector("[data-cart-drawer]");
    if (cartDrawer && cartDrawer.dataset.freeShippingThresholdCents != null) {
      var fromCart = parseInt(cartDrawer.dataset.freeShippingThresholdCents, 10);
      if (!isNaN(fromCart)) return fromCart;
    }
    var fromSection = parseInt(section.dataset.freeShippingThresholdCents, 10);
    return isNaN(fromSection) ? 0 : fromSection;
  }

  function humanizeFrequency(planName) {
    var lower = (planName || "").toLowerCase();
    if (/week/.test(lower)) return "Weekly";
    if (/fortnight|2\s*week/.test(lower)) return "Fortnightly";
    if (/month/.test(lower)) return "Monthly";
    if (/year|annual/.test(lower)) return "Yearly";
    return planName;
  }

  var state = {
    mode: "onetime",
    frequency: "",
    discount: 0,
    planMatch: "",
    planId: "",
    packSize: 4,
    priceCents: 0,
    packLabel: "4 tubs",
    variantId: "",
    sellingPlans: [],
    flavours: {},
  };

  function formatMoney(cents) {
    return (
      window.Shopify && window.Shopify.formatMoney
        ? window.Shopify.formatMoney(cents)
        : "£" + (cents / 100).toFixed(2)
    );
  }

  function setActiveItem(items, activeItem, activeClass) {
    items.forEach(function (item) {
      var isActive = item === activeItem;
      item.classList.toggle(activeClass, isActive);
      item.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function initFlavoursFromDom() {
    flavourCards.forEach(function (card) {
      var id = card.dataset.flavourId;
      var name = card.dataset.flavourName || "";
      var qtyEl = card.querySelector("[data-build-qty-value]");
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
      state.flavours[id] = { name: name, qty: qty };
    });
  }

  function getTotalQty() {
    var total = 0;
    Object.keys(state.flavours).forEach(function (id) {
      total += state.flavours[id].qty;
    });
    return total;
  }

  function getFlavourQty(card) {
    var id = card.dataset.flavourId;
    return state.flavours[id] ? state.flavours[id].qty : 0;
  }

  function setFlavourQty(card, qty) {
    var id = card.dataset.flavourId;
    if (!state.flavours[id]) {
      state.flavours[id] = { name: card.dataset.flavourName || "", qty: 0 };
    }
    state.flavours[id].qty = Math.max(0, qty);

    var qtyEl = card.querySelector("[data-build-qty-value]");
    if (qtyEl) qtyEl.textContent = String(state.flavours[id].qty);

    card.classList.toggle("build-box__flavour--active", state.flavours[id].qty > 0);
  }

  function trimFlavoursToLimit() {
    var total = getTotalQty();
    var cards = Array.prototype.slice.call(flavourCards).reverse();

    while (total > state.packSize) {
      var reduced = false;
      for (var i = 0; i < cards.length; i++) {
        var qty = getFlavourQty(cards[i]);
        if (qty > 0) {
          setFlavourQty(cards[i], qty - 1);
          total--;
          reduced = true;
          break;
        }
      }
      if (!reduced) break;
    }
  }

  function renderFreqButtons() {
    if (!freqsContainer) return;
    freqsContainer.innerHTML = "";
    var plans = state.sellingPlans || [];
    if (plans.length === 0) return;

    plans.forEach(function (plan, idx) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "build-box__freq" + (idx === 0 ? " build-box__freq--active" : "");
      btn.setAttribute("data-build-freq", "");
      btn.setAttribute("data-freq", plan.name);
      btn.setAttribute("data-discount", plan.discount || 0);
      btn.setAttribute("data-plan-match", plan.name);
      btn.setAttribute("data-plan-id", plan.id);
      btn.setAttribute("aria-pressed", idx === 0 ? "true" : "false");

      var label = document.createElement("span");
      label.className = "build-box__freq-label";
      label.textContent = humanizeFrequency(plan.name);
      btn.appendChild(label);

      if (plan.discount && plan.discount > 0 && plan.discountType === "percentage") {
        var badge = document.createElement("span");
        badge.className = "build-box__freq-badge";
        badge.textContent = "Save " + plan.discount + "%";
        btn.appendChild(badge);
      }

      btn.addEventListener("click", function () {
        if (btn.classList.contains("build-box__freq--active")) return;
        setFrequency(btn);
      });

      freqsContainer.appendChild(btn);
    });

    freqBtns = section.querySelectorAll("[data-build-freq]");

    var first = freqsContainer.querySelector(".build-box__freq--active");
    if (first) {
      state.frequency = first.dataset.freq || "";
      state.discount = parseInt(first.dataset.discount, 10) || 0;
      state.planMatch = first.dataset.planMatch || first.dataset.freq;
    }
  }

  function updateFreqVisibility() {
    if (!freqsContainer) return;
    var hasPlans = state.sellingPlans && state.sellingPlans.length > 0;
    freqsContainer.hidden = state.mode !== "subscribe" || !hasPlans;
  }

  function updateSubscribeAvailability() {
    var subscribeBtn = section.querySelector('[data-build-purchase][data-mode="subscribe"]');
    if (!subscribeBtn) return;
    var hasPlans = state.sellingPlans && state.sellingPlans.length > 0;
    subscribeBtn.disabled = !hasPlans;
    subscribeBtn.style.opacity = hasPlans ? "" : "0.4";
    subscribeBtn.style.pointerEvents = hasPlans ? "" : "none";
    if (!hasPlans && state.mode === "subscribe") {
      var onetimeBtn = section.querySelector('[data-build-purchase][data-mode="onetime"]');
      if (onetimeBtn) {
        setActiveItem(purchaseBtns, onetimeBtn, "build-box__purchase-btn--active");
        state.mode = "onetime";
      }
    }
  }

  function updateSidebarPurchase() {
    if (!sidebarPurchase) return;

    if (state.mode === "subscribe") {
      sidebarPurchase.textContent = "Subscribe & Save";
      if (sidebarSave) {
        sidebarSave.textContent = "Save " + state.discount + "%";
        sidebarSave.hidden = false;
      }
      if (sidebarPurchaseMeta) {
        sidebarPurchaseMeta.textContent = humanizeFrequency(state.frequency) + " delivery";
        sidebarPurchaseMeta.hidden = false;
      }
    } else {
      sidebarPurchase.textContent = "One-time purchase";
      if (sidebarSave) sidebarSave.hidden = true;
      if (sidebarPurchaseMeta) {
        sidebarPurchaseMeta.textContent = "No commitment";
        sidebarPurchaseMeta.hidden = false;
      }
    }
  }

  function updateSidebarPack() {
    if (sidebarPack) sidebarPack.textContent = state.packLabel;
    if (flavoursHint) {
      flavoursHint.textContent = "Add up to " + state.packSize + " tubs — mix, repeat, or go all-in on one";
    }
  }

  function updateSidebarFlavours() {
    if (!sidebarFlavours) return;
    var rows = [];
    Array.prototype.slice.call(flavourCards).forEach(function (card) {
      var id = card.dataset.flavourId;
      var entry = state.flavours[id];
      if (entry && entry.qty > 0) {
        rows.push(
          '<div class="build-box__box-row"><span>' + entry.name + "</span><span>x" + entry.qty + "</span></div>"
        );
      }
    });
    sidebarFlavours.innerHTML = rows.length > 0
      ? rows.join("")
      : '<p class="build-box__box-flavours-empty">—</p>';
  }

  function updateSidebarTotal() {
    if (!sidebarTotal) return;
    sidebarTotal.textContent = formatMoney(getBoxPriceCents());
  }

  function updateSidebarDelivery() {
    if (!sidebarDelivery) return;

    var thresholdCents = getFreeShippingThresholdCents();
    var isFree = thresholdCents > 0 && getBoxPriceCents() >= thresholdCents;
    var freeText = sidebarDelivery.dataset.deliveryText || "Delivered frozen";
    var freePrice = sidebarDelivery.dataset.deliveryPrice || "Free";
    var calculatedText = sidebarDelivery.dataset.deliveryCalculated || "Calculated at checkout";

    sidebarDelivery.classList.toggle("build-box__box-delivery--free", isFree);
    sidebarDelivery.classList.toggle("build-box__box-delivery--calculated", !isFree);

    if (sidebarDeliveryText) {
      sidebarDeliveryText.textContent = isFree ? freeText : calculatedText;
    }

    if (sidebarDeliveryPrice) {
      sidebarDeliveryPrice.textContent = freePrice;
      sidebarDeliveryPrice.hidden = !isFree;
    }
  }

  function updateProgress() {
    var total = getTotalQty();
    var limit = state.packSize;
    var isComplete = total === limit && limit > 0;
    var fillPercent = limit > 0 ? (total / limit) * 100 : 0;

    if (progress) progress.classList.toggle("build-box__progress--complete", isComplete);
    if (progressCount) {
      progressCount.textContent = isComplete ? "Box complete" : total + " of " + limit + " tubs selected";
    }
    if (progressRemain) {
      progressRemain.textContent = isComplete ? "Ready to add to cart" : limit - total + " to go";
    }
    if (progressFill) progressFill.style.width = fillPercent + "%";
    if (progressCheck) progressCheck.hidden = !isComplete;
  }

  function updateQtyControls() {
    var total = getTotalQty();
    var isFull = total >= state.packSize;

    flavourCards.forEach(function (card) {
      var qty = getFlavourQty(card);
      var minus = card.querySelector("[data-build-qty-minus]");
      var plus = card.querySelector("[data-build-qty-plus]");

      card.classList.toggle("build-box__flavour--disabled", isFull && qty === 0);
      if (minus) minus.disabled = qty <= 0;
      if (plus) plus.disabled = isFull;
    });
  }

  function updateCheckout() {
    if (!checkoutBtn) return;
    var isComplete = getTotalQty() === state.packSize && state.packSize > 0;
    checkoutBtn.disabled = !isComplete;
    checkoutBtn.classList.toggle("build-box__checkout--disabled", !isComplete);
    checkoutBtn.setAttribute("aria-disabled", isComplete ? "false" : "true");
  }

  function updateUI() {
    updateSubscribeAvailability();
    updateFreqVisibility();
    updateSidebarPurchase();
    updateSidebarPack();
    updateSidebarFlavours();
    updateSidebarTotal();
    updateSidebarDelivery();
    updateProgress();
    updateQtyControls();
    updateCheckout();
  }

  function setMode(mode) {
    state.mode = mode;
    updateUI();
  }

  function setFrequency(freqBtn) {
    state.frequency = freqBtn.dataset.freq;
    state.discount = parseInt(freqBtn.dataset.discount, 10) || 0;
    state.planMatch = freqBtn.dataset.planMatch || freqBtn.dataset.freq;
    state.planId = freqBtn.dataset.planId || "";
    setActiveItem(freqBtns, freqBtn, "build-box__freq--active");
    updateUI();
  }

  function setPack(packBtn) {
    state.packSize = parseInt(packBtn.dataset.packSize, 10) || 4;
    state.priceCents = parseInt(packBtn.dataset.priceCents, 10) || 0;
    state.packLabel = packBtn.dataset.packLabel || state.packSize + " tubs";
    state.variantId = packBtn.dataset.variantId || "";
    try {
      state.sellingPlans = JSON.parse(packBtn.dataset.sellingPlans || "[]");
    } catch (e) {
      state.sellingPlans = [];
    }
    setActiveItem(packBtns, packBtn, "build-box__pack--active");
    renderFreqButtons();
    trimFlavoursToLimit();
    updateUI();
  }

  /* ---------- Events ---------- */

  purchaseBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (btn.dataset.mode === state.mode || btn.disabled) return;
      setActiveItem(purchaseBtns, btn, "build-box__purchase-btn--active");
      setMode(btn.dataset.mode);
    });
  });

  freqBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (btn.classList.contains("build-box__freq--active")) return;
      setFrequency(btn);
    });
  });

  packBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (btn.classList.contains("build-box__pack--active")) return;
      setPack(btn);
    });
  });

  flavourCards.forEach(function (card) {
    var minus = card.querySelector("[data-build-qty-minus]");
    var plus = card.querySelector("[data-build-qty-plus]");

    if (minus) {
      minus.addEventListener("click", function () {
        if (getFlavourQty(card) <= 0) return;
        setFlavourQty(card, getFlavourQty(card) - 1);
        updateUI();
      });
    }
    if (plus) {
      plus.addEventListener("click", function () {
        if (getTotalQty() >= state.packSize) return;
        setFlavourQty(card, getFlavourQty(card) + 1);
        updateUI();
      });
    }
  });

  /* ---------- Checkout ---------- */

  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (getTotalQty() !== state.packSize || !state.variantId) return;

      if (!window.HappyJoBoxCart) {
        console.error("build-box: HappyJoBoxCart not loaded");
        return;
      }

      var properties = {};
      var count = 0;
      Array.prototype.slice.call(flavourCards).forEach(function (card) {
        var id = card.dataset.flavourId;
        var entry = state.flavours[id];
        if (entry && entry.qty > 0) {
          count++;
          properties["Flavor " + count] = entry.qty + " x " + entry.name;
        }
      });

      var sellingPlanId;
      if (state.mode === "subscribe") {
        if (state.planId) {
          sellingPlanId = state.planId;
        } else if (window.HappyJoBoxCart && window.HappyJoBoxCart.findSellingPlanId) {
          sellingPlanId = window.HappyJoBoxCart.findSellingPlanId(state.sellingPlans, state.planMatch);
        }
      }

      checkoutBtn.disabled = true;
      checkoutBtn.textContent = "Adding…";

      window.HappyJoBoxCart
        .addPackToCart({
          variantId: state.variantId,
          quantity: 1,
          properties: properties,
          sellingPlanId: sellingPlanId || undefined,
        })
        .then(function () {
          if (window.HappyJoCartDrawer && window.HappyJoCartDrawer.isEnabled()) {
            return window.HappyJoCartDrawer.openAfterAdd();
          }
          window.location.href = "/cart";
        })
        .catch(function (err) {
          alert(err.message || "Could not add to cart. Please try again.");
        })
        .then(function () {
          checkoutBtn.disabled = false;
          checkoutBtn.innerHTML =
            (section.querySelector("[data-build-checkout]") || {}).dataset
              ? checkoutBtn.dataset.label || "Add Box to Cart"
              : "Add Box to Cart";
          updateUI();
        });
    });
  }

  /* ---------- Init from DOM ---------- */

  var activePurchase = section.querySelector(".build-box__purchase-btn--active[data-build-purchase]");
  if (activePurchase && activePurchase.dataset.mode) {
    state.mode = activePurchase.dataset.mode;
  }

  var activePack = section.querySelector(".build-box__pack--active[data-build-pack]");
  if (activePack) {
    state.packSize = parseInt(activePack.dataset.packSize, 10) || 4;
    state.priceCents = parseInt(activePack.dataset.priceCents, 10) || 0;
    state.packLabel = activePack.dataset.packLabel || "4 tubs";
    state.variantId = activePack.dataset.variantId || "";
    try {
      state.sellingPlans = JSON.parse(activePack.dataset.sellingPlans || "[]");
    } catch (e) {
      state.sellingPlans = [];
    }
  }

  renderFreqButtons();

  initFlavoursFromDom();
  updateUI();
})();
